<script>
  import { _ } from 'svelte-i18n'
  import { user_valid, demos, previews_scrolled_up, previews_sort_order, flash_content } from '../stores.js'
  import { handleUpsell } from '../modules/helpers'
  import HorizontalOptionsList from '../elements/HorizontalOptionsList.svelte'

  let options = [
    {value:'ascending', display:'A&rarr;Z'}, 
    {value:'descending', display:'Z&rarr;A'}, 
    {value:'random', display:'Random'}
  ]
    
  let demoing = false
	$: if ($demos) demoing = demos.valid('sorting')
  
  if ($user_valid) $previews_sort_order = localStorage.getItem('previews_sort_order')
  $: if ($user_valid) localStorage.setItem("previews_sort_order", $previews_sort_order)
  
  let counter = 0;
  $: $previews_sort_order, counter++
  $: if (counter > 1) $flash_content = {
    message: $_('flashes.sortOrder', { values: { sort_order: $previews_sort_order } }),
  }

</script>

<div 
class:hidden={$previews_scrolled_up}
class:pro_only={!$user_valid}
class:demoing
on:click={() => handleUpsell('sorting')}>
  <HorizontalOptionsList list_options={options} bind:selected_option={$previews_sort_order}/>
</div>

<style>
  div {
    position: relative;
  }
  div.hidden {
    display: none;
  }
</style>